import styled from "styled-components";

export const StyledSettingsIcon = styled.div`
  width: 100%;
  height: 100%;
  padding: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
